import { Component, Fragment, h } from 'preact';
import { FinText } from '../../../i18n';
import { Locations, Properties, TravelType } from '../../../common';
import { BookingState, connectStore } from '../../../store';
import { WithStyles, withStyles } from '../../../style';
import Notification, { Severity } from '../Notification/Notification';
import Icon from '../../../common/Icon/Icon';
import { withText } from 'preact-i18n';
import { asCmsLang } from '../../../utils';

interface StoreProps {
  open: boolean;
  travelType: TravelType;
  locale: string;
  locations: Locations;
}

interface TranslationProps {
  multiCityUrl: string;
}

type EffectiveProps = Properties & StoreProps & WithStyles & TranslationProps;

const mapStateToProps = ({
  ux: {
    warnings: { noFlights },
  },
  selection: { travelType, locale, locations, activeLocationIndex },
}: BookingState): StoreProps => ({
  locations: locations[activeLocationIndex],
  open: noFlights,
  travelType,
  locale,
});

@withStyles()
@withText({
  multiCityUrl: 'notification.multiCity.seeMoreLink.url',
})
@connectStore({ mapStateToProps })
export default class NoFlightsNotification extends Component<Properties> {
  render({ open, travelType, tx, multiCityUrl, locale, locations }: EffectiveProps): h.JSX.Element {
    return (
      <Notification open={open} severity={Severity.ERROR}>
        {travelType === TravelType.MULTI_CITY
          ? open && (
              <Fragment>
                <FinText id="notification.multiCity.noFlightsFound" />
                <a
                  class={tx('underline medium-type link-hover nordic-blue-900-text font-body-1 ms-xxsmall-l')}
                  href={multiCityUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FinText id="notification.multiCity.seeMoreLinkText" />
                  <Icon iconName="external-tab" class={tx('is-xsmall')} />
                </a>
              </Fragment>
            )
          : open && (
              <Fragment>
                <FinText id="notification.noFlights" />
                <FinText id="notification.timetable.checkTimeTableText" />
                <p>
                  <a
                    className={tx('underline medium-type link-hover nordic-blue-900-text font-body-1')}
                    href={`/${asCmsLang(locale)}/timetables?dest=${locations.destination.locationCode}&origin=${
                      locations.origin.locationCode
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FinText id="notification.timetable.forRouteLinkText" />
                  </a>
                </p>
              </Fragment>
            )}
      </Notification>
    );
  }
}
